import React, { useLayoutEffect, useContext, useState, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useWindowSize } from 'react-use';


import Header, { HeaderLeft, HeaderRight } from '../../../layout/Header/Header';
import Popovers from '../../../components/bootstrap/Popovers';
import Button, { IButtonProps } from '../../../components/bootstrap/Button';
import useDarkMode from '../../../hooks/useDarkMode';
import LANG, { getLangWithKey, ILang } from '../../../lang';
import Dropdown, {
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
} from '../../../components/bootstrap/Dropdown';
import showNotification from '../../../components/extras/showNotification';
import Icon from '../../../components/icon/Icon';
import Spinner from '../../../components/bootstrap/Spinner';
import AuthContext from '../../../contexts/authContext';
import ThemeContext from '../../../contexts/themeContext';
import { demoPagesMenu } from '../../../menu';
import useNavigationItemHandle from 'src/hooks/useNavigationItemHandle';
import { getStorage, setStorage } from 'src/utils/utils';
import { StaffService } from 'src/services/UserServices';
import moment from 'moment';
import { BsFillLockFill } from 'react-icons/bs';
import ModalChangePass from './ModalChangePass';
import ModalProfile from './ModalProfile';

// IMG
import UserImage from 'src/assets/img/wanna/wanna1.png';
import UserImageWebp from 'src/assets/img/wanna/wanna1.webp';

const DashboardHeader = () => {
	const navigate = useNavigate();
	const { width } = useWindowSize();
	const { i18n, t } = useTranslation();
	const { setAsideStatus } = useContext(ThemeContext);
	// const { userData, setUser } = useContext(AuthContext);
	const [isopen, setIsopen] = useState(false);
	const { darkModeStatus, setDarkModeStatus } = useDarkMode();
	const handleItem = useNavigationItemHandle();
	const username = getStorage('username');
	const [isOpenModalChangepass, setIsOpenModalChangepass] = useState(false);
	const [oldPass, setOldPass] = useState('');
	const [newPass, setNewPass] = useState('');
	const [isOpenModalProfile, setIsOpenModalProfile] = useState(false);

	const [time, setTime] = useState(moment().format('DD/MM/YYYY HH:mm'));

	setInterval(() => {
		setTime(moment().format('DD/MM/YYYY HH:mm'));
	}, 1000);

	interface ModalChangePass {
		isopen: any;
		exit: any;
		handleChangeData: any;
	}

	const styledBtn: IButtonProps = {
		color: darkModeStatus ? 'dark' : 'light',
		hoverShadow: 'default',
		isLight: !darkModeStatus,
		size: 'lg',
	};

	const handleSubmitChangePass = () => {
		StaffService.changePassword({ old_password: oldPass, new_password: newPass })
			.then(({ data }) => {
				setOldPass('');
				setNewPass('');
				setIsOpenModalChangepass(false);
				showNotification(
					<span className='d-flex align-items-center'></span>,
					`Successfully`,
				);
			})
			.catch((err) => {
				showNotification(
					<span className='d-flex align-items-center'></span>,
					`${err?.response?.data?.message}`,
				);
			});
	};

	const changeLanguage = (lng: ILang['key']['lng']) => {
		setStorage('i18nextLng', lng);
		i18n.changeLanguage(lng).then(() =>
			showNotification(
				<span className='d-flex align-items-center'>
					<Icon icon={getLangWithKey(lng)?.icon} size='lg' className='me-1' />
					<span>{`${t('txt_language_changed_to')} ${getLangWithKey(lng)?.text}`}</span>
				</span>,
				`${t('txt_successfully')}`,
			),
		);
	};

	/**
	 * Language attribute
	 */
	useLayoutEffect(() => {
		document.documentElement.setAttribute('lang', i18n.language);
	});

	return (
		<Header>
			<HeaderLeft>
				<code>{time}</code>
			</HeaderLeft>

			<HeaderRight>
				<div className='row g-3 align-items-center'>
					{/* Dark Mode */}
					<div className='col-auto'>
						<Popovers trigger='hover' desc='Dark / Light mode'>
							<Button
								// eslint-disable-next-line react/jsx-props-no-spreading
								{...styledBtn}
								onClick={() => setDarkModeStatus(!darkModeStatus)}
								className='btn-only-icon'
								data-tour='dark-mode'
								aria-label='Toggle dark mode'>
								<Icon
									icon={darkModeStatus ? 'DarkMode' : 'LightMode'}
									color={darkModeStatus ? 'info' : 'warning'}
									className='btn-icon'
								/>
							</Button>
						</Popovers>
					</div>
					{/* Lang Selector */}
					<div className='col-auto'>
						<Dropdown>
							<DropdownToggle hasIcon={false}>
								{typeof getLangWithKey(i18n.language as ILang['key']['lng'])
									?.icon === 'undefined' ? (
									<Button
										// eslint-disable-next-line react/jsx-props-no-spreading
										{...styledBtn}
										className='btn-only-icon'
										aria-label='Change language'
										data-tour='lang-selector'>
										<Spinner isSmall inButton='onlyIcon' isGrow />
									</Button>
								) : (
									<Button
										// eslint-disable-next-line react/jsx-props-no-spreading
										{...styledBtn}
										aria-label='Change language'
										data-tour='lang-selector'>
										<img
											className='img_icon_lang'
											src={
												getLangWithKey(i18n.language as ILang['key']['lng'])
													?.icon
											}
											alt={''}
										/>
									</Button>
								)}
							</DropdownToggle>
							<DropdownMenu isAlignmentEnd data-tour='lang-selector-menu'>
								{Object.keys(LANG).map((i) => (
									<DropdownItem key={LANG[i].lng}>
										<div>
											<img
												className='img_icon_lang'
												src={LANG[i].icon}
												alt={LANG[i].text}
											/>
											<Button onClick={() => changeLanguage(LANG[i].lng)}>
												{LANG[i].text}
											</Button>
										</div>
									</DropdownItem>
								))}
							</DropdownMenu>
						</Dropdown>
					</div>
					{/* USER */}
					<div className='col-auto'>
						<Dropdown isOpen={isopen} setIsOpen={function noRefCheck() {}}>
							<DropdownToggle>
								<div className='user-avatar' style={{ cursor: 'pointer' }}>
									<img
										onClick={() => setIsopen(!isopen)}
										srcSet={UserImageWebp}
										src={UserImage}
										alt='Avatar'
										width={128}
										height={128}
									/>
								</div>
							</DropdownToggle>
							<DropdownMenu>
								<DropdownItem isHeader>
									<div
										role='presentation'
										className='navigation-item cursor-pointer'
										onClick={() => {
											setIsopen(false);
											setIsOpenModalProfile(true);
										}}>
										<span className='navigation-link navigation-link-pill'>
											<span className='navigation-link-info'>
												<Icon
													icon='AccountBox'
													className='navigation-icon'
												/>
												<span className='navigation-text'>
													{t('txt_profile')}
												</span>
											</span>
										</span>
									</div>
								</DropdownItem>
								<DropdownItem>
									<div
										role='presentation'
										className='navigation-item cursor-pointer'
										onClick={() => {
											setIsopen(false);
											setIsOpenModalChangepass(true);
										}}>
										<span className='navigation-link navigation-link-pill'>
											<span className='navigation-link-info'>
												<Icon icon='lock' className='navigation-icon' />
												<span className='navigation-text'>
													{t('txt_change_password')}
												</span>
											</span>
										</span>
									</div>
								</DropdownItem>
								<DropdownItem isDivider />
								<DropdownItem>
									<div
										role='presentation'
										className='navigation-item cursor-pointer'
										onClick={() => {
											setIsopen(false);
											// if (setUser) {
											// 	setUser('');
											// }
											if (
												width <
												Number(process.env.REACT_APP_MOBILE_BREAKPOINT_SIZE)
											) {
												setAsideStatus(false);
											}
											navigate('/logout');
										}}>
										<span className='navigation-link navigation-link-pill'>
											<span className='navigation-link-info'>
												<Icon icon='Logout' className='navigation-icon' />
												<span className='navigation-text'>
													{t('txt_logout')}
												</span>
											</span>
										</span>
									</div>
								</DropdownItem>
							</DropdownMenu>
						</Dropdown>
						<ModalChangePass
							isOpen={isOpenModalChangepass}
							exit={() => setIsOpenModalChangepass(false)}
							oldPass={oldPass}
							newPass={newPass}
							setOldPass={setOldPass}
							setNewPass={setNewPass}
							handleSubmit={handleSubmitChangePass}
							t={t}
						/>
						<ModalProfile
							isOpen={isOpenModalProfile}
							exit={() => setIsOpenModalProfile(false)}
						/>
					</div>
				</div>
			</HeaderRight>
		</Header>
	);
};

export default DashboardHeader;
